var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUploadFileIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_8116_48904",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 17,
    height: 17
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.135498,
    y: 0.15625,
    width: 16,
    height: 16,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_8116_48904)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.46879 12.7886H8.80213V9.98523L9.87679 11.0599L10.8101 10.1139L8.13546 7.43923L5.46079 10.1139L6.41079 11.0432L7.46879 9.98523V12.7886ZM4.18329 14.9559C3.76351 14.9559 3.40579 14.8081 3.11013 14.5124C2.81446 14.2167 2.66663 13.859 2.66663 13.4392V2.86823C2.66663 2.44845 2.81446 2.09073 3.11013 1.79506C3.40579 1.4994 3.76351 1.35156 4.18329 1.35156H9.52462L13.6043 5.43123V13.4392C13.6043 13.859 13.4565 14.2167 13.1608 14.5124C12.8651 14.8081 12.5074 14.9559 12.0876 14.9559H4.18329ZM8.75429 6.20156V2.86823H4.18329V13.4392H12.0876V6.20156H8.75429Z",
    fill: "#1D5AE8"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadFileIcon);
export default __webpack_public_path__ + "static/media/UploadFileIcon.da8a96af56d85d5c06737656a9497443.svg";
export { ForwardRef as ReactComponent };